import { render, staticRenderFns } from "./renz_msg.vue?vue&type=template&id=d85eb754&scoped=true&"
import script from "./renz_msg.vue?vue&type=script&lang=js&"
export * from "./renz_msg.vue?vue&type=script&lang=js&"
import style0 from "./renz_msg.vue?vue&type=style&index=0&id=d85eb754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85eb754",
  null
  
)

export default component.exports